export var reduxKey = '@@ADS';
export var actionKey = '@@ADS';
//# sourceMappingURL=constants.js.map